<template>
  <div id="dbLogin" class="db-login">
    <div class="left">
      <img :src="backLoginImage" alt="">
    </div>
    <div class="right"></div>
    <div class="fixed">
      <div class="logo-name-container">
        <!-- <img
          class="site-logo"
          width="24"
          height="24"
          src="../../../assets/admin-login/login-icon@1x.png"
        />-->
        <img
          class="site-name"
          width="80"
          height="28"
          :src="logo"
        />
      </div>
      <div class="desc-container">
        <p class="desc-ch">后台管理系统</p>
        <p class="desc-en">Business Management System</p>
      </div>
      <div class="login-error-tip">
        <span class="error-desc">{{errorTip}}</span>
      </div>
      <el-form
        status-icon
        class="login-form"
        ref="userInfo"
        :model="userInfo"
        :rules="userInfoRules"
      >
        <el-form-item class="login-form-label" prop="username">
          <el-input
            class="login-form-input"
            type="text"
            v-model="userInfo.username"
            auto-complete="off"
            placeholder="请输入账号"
            @keyup.enter.native="dbLogin"
          ></el-input>
        </el-form-item>
        <el-form-item class="login-form-label" prop="password">
          <el-input
            class="login-form-input"
            type="password"
            v-model="userInfo.password"
            auto-complete="off"
            placeholder="请输入密码"
            @keyup.enter.native="dbLogin"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="login-form-btn" type="primary" @click="dbLogin">登录</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import {
  saveToken,
  saveDBUserRealName,
  saveXBBasicInformation,
  getXBBasicInformation
} from "common/js/storage";
import storage from "good-storage";
import DBUser from "models/db/user.js";
const dbUser = new DBUser();
import DBHome from 'models/db/home.js';
const dbHome = new DBHome();
export default {
  data() {
    return {
      // 异常提示文字
      errorTip: "",
      // 登录表单字段
      userInfo: {
        username: "",
        password: ""
      },
      // 验证规则
      userInfoRules: {
        username: {
          required: true,
          message: "请输入账号",
          trigger: "blur"
        },
        password: {
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }
      },    
      labelLogo: '',
      logo:'',
      backLoginImage: ''
    };
  },
  created() {
    this.logo = getXBBasicInformation().logo
    this.backLoginImage = getXBBasicInformation().backLoginImage
    this.basicInformation();
    // let logo = "http://image.8844it.com/ydb2/2/微信图片_20190703170744.jpg";
    // let link = `<link rel="icon" href="${logo}">`;
    // let tempNode = document.createElement("div");
    // tempNode.innerHTML = link;
    // document.querySelector("head").append(tempNode.firstChild);
  },
  watch: {
    labelLogo: function(newvalue, oldvalue) {
      let link = `<link rel="icon" href="${this.labelLogo}">`;
      let tempNode = document.createElement('div');
      tempNode.innerHTML = link;
      document.querySelector('head').append(tempNode.firstChild);
    }
  },
  methods: {
    dbLogin(formName) {
      this.$refs.userInfo.validate(valid => {
        if (valid) {
          // 字段验证通过，这里开始执行登录逻辑
          this._login(this.userInfo);
        } else {
          return false;
        }
      });
    },
    _login(userInfo) {
      dbUser
        .login(userInfo)
        .then(res => {
          if (res.success) {
            // 存储token令牌
            saveToken(res.result.token);
            saveDBUserRealName(res.result.name);
            console.log(res.result.name);
            storage.set("DBUserName", res.result.username);
            // 跳转CMS主页面
            this.$router.push({
              path: "/admin"
            });
          } else {
            this.errorTip = res.message;
          }
        })
        .catch(e => {
          console.log("登陆失败");
        });
    },
    // 获取基础信息
    basicInformation() {
      // if (getXBBasicInformation() === '') {
        dbHome.getXBBasicInformation().then(res => {
          if (res.success) {
            this.labelLogo = res.result.labelLogo;
            document.querySelector('title').innerHTML = res.result.mallName;
            saveXBBasicInformation(res.result);
          }
        });
      // } else {
      //   this.labelLogo = getXBBasicInformation().labelLogo;
      //   document.querySelector(
      //     'title'
      //   ).innerHTML = getXBBasicInformation().mallName;
      // }
    },
  },
  components: {}
};
</script>
<style lang="scss" scoped>
.db-login {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: row;
  .left {
    // flex-grow: 1;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      height: 100%;
    }
    // background-image: url("../../../assets/admin-login/login-bg.jpg");
    background-size: cover;
    background-repeat: no-repeat;
  }
  // .right {
  //   background-color: #df3445;
  //   height: 100%;
  //   width: 360px;
  // }
  .fixed {
    width: 360px;
    height: 480px;
    position: fixed;
    top: 50%;
    margin-top: -240px;
    right: 180px;
    box-sizing: border-box;
    padding: 20px 20px 30px 20px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 6px 5px 6px 0px rgba(81, 46, 46, 0.5);
    .logo-name-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-top: 2px;
      .site-logo {
        margin-right: 16px;
      }
    }
    .desc-container {
      margin-top: 84px;
      margin-bottom: 12px;
      .desc-ch {
        height: 32px;
        line-height: 32px;
        font-size: 24px;
        font-weight: 500;
        color: rgba(48, 49, 51, 1);
        letter-spacing: 1pt;
      }
      .desc-en {
        height: 22px;
        line-height: 22px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(96, 98, 102, 1);
        letter-spacing: 1pt;
      }
    }
    .login-error-tip {
      font-size: 12px;
      color: red;
      margin-bottom: 6px;
    }
    .login-form {
      font-family: "PingFangSC-Regular";
      font-weight: 400;
      letter-spacing: 1pt;
      .login-form-label {
        margin-bottom: 24px;
        .login-form-input::-webkit-input-placeholder {
          font-size: 16px;
          color: rgba(96, 98, 102, 1);
          line-height: 24px;
        }
        .cannot-login {
          position: absolute;
          top: 100%;
          right: 0;
          font-size: 12px;
          color: rgba(61, 116, 242, 0.75);
          line-height: 20px;
          cursor: pointer;
          &:hover {
            color: rgba(61, 116, 242, 1);
          }
        }
      }
      .login-form-btn {
        width: 100%;
        height: 48px;
        background: rgba(223, 52, 69, 1);
        box-shadow: 0px 8px 16px -1px rgba(212, 33, 33, 0.29);
        border-radius: 8px;
        border: none;
        outline: none;
        font-size: 16px;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
        &:active {
          background: #e76774;
        }
      }
    }
  }
}
</style>

<style lang="scss">
/* 覆盖 el-form 样式 */
#dbLogin {
  .el-form {
    .el-form-item {
      .el-form-item__content {
        .el-input {
          .el-input__inner {
            height: 48px;
          }
        }
      }
    }
  }
}
</style>
